import { useQuery } from '@tanstack/react-query'
import { getTransactionsAdmin } from '@/queries/transactions/queries.ts'
import { AdminTransactionsSchemaType } from '@/queries/transactions/transactions.types.ts'

type Identifier = { provider_id: number } | { applicant_id: number }

export const GET_ADMIN_TRANSACTIONS_QUERY_KEY = (
  program_id: number,
  recordsPerPage: number,
  global_on_id: number,
  locale: string,
  identifier: Identifier
) => [
  'adminTransactions',
  program_id,
  recordsPerPage,
  global_on_id,
  locale,
  identifier,
]

export const useAdminTransactions = (
  program_id: number,
  recordsPerPage: number,
  global_on_id: number,
  locale: string,
  identifier: Identifier
) => {
  const queryKey = GET_ADMIN_TRANSACTIONS_QUERY_KEY(
    program_id,
    recordsPerPage,
    global_on_id,
    locale,
    identifier
  )

  const isEnabled =
    !!program_id && !!recordsPerPage && !!global_on_id && !!locale

  return useQuery<AdminTransactionsSchemaType>({
    queryKey,
    queryFn: () =>
      getTransactionsAdmin(
        program_id,
        recordsPerPage,
        global_on_id,
        locale,
        identifier
      ),
    enabled: isEnabled,
  })
}
